import PocketBase from 'pocketbase';

const pb = new PocketBase('https://bangchu-api.dreace.top/');

// 启用自动刷新 token
pb.autoCancellation(false);

// 监听认证状态变化
pb.authStore.onChange(() => {
    console.log('authStore changed', pb.authStore.isValid);
});

export const getCurrentUser = () => {
    if (!pb.authStore.isValid) {
        return null
    }
    pb.collection('users').authRefresh().then(
        (record) => {
            console.log('authRefresh', record);
        }
    );
    return pb.authStore.record;
};

export default pb;